import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { pricingSimulatorUrls } from 'config/urls';

interface outputType {
    loading: boolean;
    mutate: UseMutateFunction<AxiosResponse<any, any> | undefined, Error, any, unknown>;
}

function useUpdateLastViewedLense(): outputType {
    // Queries
    const { isPending, isPaused, mutate } = useMutation({
        mutationFn: async (inputData: any) => {
            //write onsuccess and onerror where mutate function is called
            try {
                const payload = {
                    scenario_id: inputData.scenarioId?.toString(),
                    user_email: inputData.userId,
                    lens_id: inputData.lensId,
                };

                const url = pricingSimulatorUrls.postUpdateLastViewedLense;

                const data = await axios({
                    method: 'post',
                    url,
                    data: { ...payload },
                });
                return data;
            } catch (error) {
                console.log('err ', error);
                throw error;
            }
        },
    });
    const apiLoading = isPaused || isPending;

    const outputData: outputType = {
        loading: apiLoading,
        mutate,
    };
    return outputData;
}

export default useUpdateLastViewedLense;
